import ErrorIcon from '@mui/icons-material/Warning';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

export const ErrorMessage = (props: {
  messageId?: string;
  sx?: SxProps<Theme>;
}) => {
  const { messageId } = props;
  const intl = useIntl();
  return (
    <Box
      sx={{
        ...props.sx,
        visibility: !messageId ? 'hidden' : 'unset',
        color: '#d00070',
        display: 'flex',
      }}
    >
      <ErrorIcon sx={{ width: 20, height: 20 }} />
      <Typography sx={{ pl: 2, fontSize: 12 }}>
        {messageId ? intl.formatMessage({ id: messageId }) : 'none'}
      </Typography>
    </Box>
  );
};
